import api from '../api/axiosInstance';

/**
 * Gère les erreurs Axios et extrait un message pertinent
 * @param {any} error
 * @returns {never}
 */
function handleError(error) {
  // Affiche l'erreur détaillée pour debug
  console.error('UserService error:', error);
  if (error.response && error.response.data && error.response.data.message) {
    throw new Error(error.response.data.message);
  }
  throw error;
}

const userService = {
  async getAllUsers() {
    try {
      const { data } = await api.get('/users');
      return data;
    } catch (error) {
      handleError(error);
    }
  },

  async createUser(userData) {
    try {
      const { data } = await api.post('/users', userData);
      return data;
    } catch (error) {
      handleError(error);
    }
  },

  async getUserById(userId) {
    try {
      const { data } = await api.get(`/users/${userId}`);
      return data;
    } catch (error) {
      handleError(error);
    }
  },

  async updateUser(userId, userData) {
    try {
      const { data } = await api.put(`/users/${userId}`, userData);
      return data;
    } catch (error) {
      handleError(error);
    }
  },

  async updateUserRole(userId, newRole) {
    try {
      const { data } = await api.patch(`/users/${userId}/role`, { role: newRole });
      return data;
    } catch (error) {
      handleError(error);
    }
  },

  async updateUserStatus(userId, status) {
    try {
      const { data } = await api.patch(`/users/${userId}/status`, { status });
      return data;
    } catch (error) {
      handleError(error);
    }
  },

  async deleteUser(userId) {
    try {
      const { data } = await api.delete(`/users/${userId}`);
      return data;
    } catch (error) {
      handleError(error);
    }
  },

  async getUserStats() {
    try {
      const { data } = await api.get('/users/stats');
      return data;
    } catch (error) {
      handleError(error);
    }
  },

  async searchUsers(criteria = {}) {
    try {
      const params = new URLSearchParams();

      if (criteria.search) params.append('search', criteria.search);
      if (criteria.role) params.append('role', criteria.role);
      if (criteria.status) params.append('status', criteria.status);
      if (criteria.page !== undefined) params.append('page', criteria.page);
      if (criteria.size !== undefined) params.append('size', criteria.size);

      const { data } = await api.get(`/users/search?${params.toString()}`);
      return data;
    } catch (error) {
      handleError(error);
    }
  }
};

export default userService;
